<!-- <app-navbar></app-navbar>
<div class="login-container">
  <div class="login-card">
      
      <div class="div-login">
          <img src="assets/header.svg" alt="Logo" class="login-logo">
      </div>
      <form [formGroup]="loginForm" (submit)="onSubmit()">
          <div class="input-group">
             
              <input type="email" id="email" formControlName="usuario" name="email" placeholder="Digite seu usuário">
          </div>
          <div class="input-group">
              
              <input type="password" id="password"  formControlName="password" name="password" placeholder="Digite sua senha">
          </div>
          <button type="submit" class="form-button">Entrar</button>
      </form>
  </div>
</div>
<app-alert /> -->

<app-navbar></app-navbar>

<div
  class="login-wrapper flex min-h-[calc(100vh-var(--navbar-height,64px))] flex-col bg-light-color px-6 py-6 font-base text-dark-color">
  <div class="mx-auto flex w-full max-w-5xl flex-col gap-5">
    <header
      class="rounded-2xl bg-gradient-to-r from-[var(--primary-color)] via-[var(--primary-color-hover)] to-[var(--second-color)] px-6 py-6 text-light-color shadow-[0_14px_40px_var(--box-shadow-color)]">
      <p class="text-xs uppercase tracking-[0.12em] text-light-color/80">Acesso administrativo</p>
      <h1 class="text-2xl font-semibold leading-tight">Entre para gerenciar o painel</h1>
      <p class="mt-2 max-w-3xl text-sm text-light-color/90">
        Use suas credenciais para acessar os dados de clientes e controlar bloqueios com segurança.
      </p>
    </header>

    <section class="flex justify-center">
      <div class="w-full max-w-lg rounded-xl border border-border-color bg-white px-6 py-6 shadow-[0_12px_36px_var(--box-shadow-color)] sm:px-8 sm:py-8">
        <div class="mb-4 flex flex-col gap-1">
          <p class="text-xs uppercase tracking-[0.12em] text-primary-color">Login</p>
          <h2 class="text-lg font-semibold text-dark-color">Informe suas credenciais</h2>
          <p class="text-sm text-dark-color/70">Acesse sua conta para continuar.</p>
        </div>

        <form [formGroup]="loginForm" (submit)="onSubmit()" class="flex flex-col gap-4" novalidate>
          <label class="flex flex-col gap-2 text-sm text-dark-color" for="email">
            <span class="text-dark-color/80">Usuário</span>
            <input
              id="email"
              type="email"
              name="email"
              formControlName="usuario"
              placeholder="Digite seu usuário"
              autocomplete="username"
              class="rounded-base border border-border-color px-3 py-2 text-sm outline-none focus:border-primary-color focus:ring-2 focus:ring-primary-color/30" />
          </label>

          <label class="flex flex-col gap-2 text-sm text-dark-color" for="password">
            <span class="text-dark-color/80">Senha</span>
            <input
              id="password"
              type="password"
              name="password"
              formControlName="password"
              placeholder="Digite sua senha"
              autocomplete="current-password"
              class="rounded-base border border-border-color px-3 py-2 text-sm outline-none focus:border-primary-color focus:ring-2 focus:ring-primary-color/30" />
          </label>

          <button
            type="submit"
            class="rounded-base bg-primary-color px-4 py-3 text-sm font-semibold text-white shadow-md transition hover:bg-primary-hover focus:outline-none focus:ring-2 focus:ring-primary-color/40">
            Entrar
          </button>
        </form>
      </div>
    </section>
  </div>
</div>

<app-alert></app-alert>
